import { CurrentAccount, CurrentProfile, RegistrationStatus } from "PFCore/types";

export const shouldShowTerms = (account: CurrentAccount, profile: CurrentProfile): boolean =>
  !!account.customization.showTermsAndConditions &&
  profile.registrationStatus === RegistrationStatus.Active &&
  !profile.agreeToTermsAndConditions;

export const isRegistrationComplete = (profile: CurrentProfile) =>
  profile.registrationStatus === RegistrationStatus.Active;

export const isAccountSwitched = (profile: CurrentProfile, account: CurrentAccount) =>
  profile.accountId !== account.id;
